import React from "react";
import Cards from "./Cards";
import "./HomePage.css";
const HomePage = () => {
  return (
    <div className="home">
      <h1>DANCE FOR CHANGE</h1>
      <Cards />
    </div>
  );
};

export default HomePage;
